import React, { PropTypes, Component } from 'react'

import './RescheduleDurationField.scss'
import HoursCounter from 'components/HoursCounter'

class RescheduleDurationField extends Component {
  constructor (props) {
    super(props)
    this.state = {
      value: this.props.initialValue
    }

    this.onDurationChanged = this.onDurationChanged.bind(this)
  }

  onDurationChanged (hours) {
    this.setState({ value: hours })
    this.props.onChange(hours)
  }

  createInput () {
    const { value } = this.state
    return {
      value,
      onChange: this.onDurationChanged
    }
  }

  render () {
    const { min, max } = this.props
    const input = this.createInput()

    return (
      <div className='RescheduleDurationField'>
        <h3>Duración del servicio</h3>
        <HoursCounter
          input={input}
          min={min}
          max={max}
          />
      </div>
    )
  }
}
RescheduleDurationField.displayName = 'RescheduleDurationField'
RescheduleDurationField.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  initialValue: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired
}
RescheduleDurationField.defaultProps = {
  min: 3,
  max: 8
}

export default RescheduleDurationField



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/RescheduleDurationField/RescheduleDurationField.js